import { render, staticRenderFns } from "./HomeFeed.vue?vue&type=template&id=163ea2c2&scoped=true"
import script from "./HomeFeed.vue?vue&type=script&lang=js"
export * from "./HomeFeed.vue?vue&type=script&lang=js"
import style0 from "./HomeFeed.vue?vue&type=style&index=0&id=163ea2c2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163ea2c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('163ea2c2')) {
      api.createRecord('163ea2c2', component.options)
    } else {
      api.reload('163ea2c2', component.options)
    }
    module.hot.accept("./HomeFeed.vue?vue&type=template&id=163ea2c2&scoped=true", function () {
      api.rerender('163ea2c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/home/HomeFeed.vue"
export default component.exports